// extracted by mini-css-extract-plugin
export var chevronIcon = "_dg-2";
export var teamName = "_dg-1";
export var teamSwitcherButton = "_dg-0";